

var user_pic = require("../assets/images/user_profile.jpg");
var pic_loader = require("../assets/images/loader.gif");
var placeholder = require("../assets/images/placeholder.png");
var trash_loader = require("../assets/images/trash.gif");
var instructions = require("../assets/images/Instruction.jpg");



const IMGS = {
  user_pic, pic_loader, placeholder, trash_loader, instructions
};


export default {
  ...IMGS
};